import React from "react";
import { Fade } from "react-reveal";
import "./Cta.css";

export default function Cta() {
  return (
    <Fade up>
      <div className="cta" id="cta">
        <div className="container">
          <h3>
            Enroll in Wellingtonia International School today, and watch your
            child thrive in a system designed to build winners, not just
            test-takers.
          </h3>
          <a
            href="https://forms.gle/UE7YqR5ni6XUtzip9"
            target={"_blank"}
            rel="noreferrer"
            className="join-wellingtonia"
          >
            Enroll Today
          </a>
        </div>
        <div className="image"></div>
      </div>
    </Fade>
  );
}
